import React from 'react'

export default ({ employee }) => (
  <tr
    key={employee.id}
    className="business-reservation__line business-employee__line"
  >
    <td className="business-employee__name">
      <img
        src={employee.profileImage}
        alt={employee.name}
        className="business-employee__name-icon mr10"
      />
      <p className="pt7">{employee.name}</p>
    </td>
    <td className="business-reservation__list-id">{employee.email}</td>
  </tr>
)
